import BillingsOrderRelatedTaxiRailyRequest from "../../../../../api/raily/billings/order/related/taxi-raily/billings-order-related-taxi-raily.request";
import BillingsOrderRelatedTaxiRailyParams from "./billings-order-related-taxi-raily-params";

const createRequest = (
  params: BillingsOrderRelatedTaxiRailyParams,
): BillingsOrderRelatedTaxiRailyRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const billingsOrderRelatesTaxiRailyParamsFactory = {
  createRequest,
};

export default billingsOrderRelatesTaxiRailyParamsFactory;
